import { render, staticRenderFns } from "./item-select.vue?vue&type=template&id=531b2cb8"
import script from "./item-select.vue?vue&type=script&lang=js"
export * from "./item-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531b2cb8')) {
      api.createRecord('531b2cb8', component.options)
    } else {
      api.reload('531b2cb8', component.options)
    }
    module.hot.accept("./item-select.vue?vue&type=template&id=531b2cb8", function () {
      api.rerender('531b2cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/send-list/conversations/item-select.vue"
export default component.exports